import { createAction, props } from '@ngrx/store';

import { MenuCategory } from '@shared/header/models/category.model';

export const LookbookActionTypes = {
    LOOKBOOK_PAGE_CREATED: '[Lookbook] LOOKBOOK_PAGE_CREATED',
    LOOKBOOK_PAGE_INITIALIZED: '[Lookbook] LOOKBOOK_PAGE_INITIALIZED',
    LOAD_LOOKBOOK_PAGE_SUCCESS: '[Lookbook] LOAD_LOOKBOOK_PAGE_SUCCESS',
    LOOKBOOK_SLUG_LOADED: '[Lookbook] LOOKBOOK_SLUG_LOADED',
    REPLACE_LOCATION_SUCESS: '[Lookbook] REPLACE_LOCATION_SUCESS',
    LOOKBOOK_PAGE_DESTROYED: '[Lookbook] LOOKBOOK_PAGE_DESTROYED',
    LOOKBOOK_PAGE_CLEAN: '[Lookbook] LOOKBOOK_PAGE_CLEAN',
};

export const LookbookPageInitialized = createAction(
    LookbookActionTypes.LOOKBOOK_PAGE_INITIALIZED,
    props<{ slug: string }>(),
);

export const LookbookPageCreated = createAction(LookbookActionTypes.LOOKBOOK_PAGE_CREATED);

export const LookbookPageDestroyed = createAction(LookbookActionTypes.LOOKBOOK_PAGE_DESTROYED);

export const LookbookPageClean = createAction(LookbookActionTypes.LOOKBOOK_PAGE_CLEAN);

export const LookbookSlugLoaded = createAction(
    LookbookActionTypes.LOOKBOOK_SLUG_LOADED,
    props<{ snapshotFragment: string }>(),
);

export const LoadLookbookPageSuccess = createAction(
    LookbookActionTypes.LOAD_LOOKBOOK_PAGE_SUCCESS,
    props<{ category: MenuCategory; slug: string; isLimited: boolean }>(),
);
